import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseStore } from "@/Common/Stores/BaseStore";
import { RequestMapper } from "@/Common/Stores/Handlers/Server/RequestMapper";
import { IPrescriptionTabModel } from "@/Patient/Models/UI/Medication/IPrescriptionTabModel";
import { PrescriptionRenewalInboxSettings } from "@/PrescriptionRenewals/Models/PrescriptionRenewalInboxSettings";
import { PrescriptionRenewalMedicationHistoryFilterSettingModel } from "@/PrescriptionRenewals/Models/PrescriptionRenewalMedicationHistoryFilterSettingModel";
import { PrescriptionRenewalMedications } from "@/PrescriptionRenewals/Models/PrescriptionRenewalMedications";
import { PrescriptionRenewalModel } from "@/PrescriptionRenewals/Models/PrescriptionRenewalModel";
import { PrescriptionRenewalsHandler } from "./Handlers/Local/PrescriptionRenewal/PrescriptionRenewalHandler";

let defaultInstance: PrescriptionRenewalsStore;

class PrescriptionRenewalsStore extends BaseStore {
    private prescriptionRenewalsHandler: PrescriptionRenewalsHandler;
    private Mapper: RequestMapper;

    public prescriptionRenewalModel: PrescriptionRenewalModel;
    public prescriptionRenewalInboxSettings: PrescriptionRenewalInboxSettings;
    public prescriptionRenewalCachedModel: {
        [prescriptionRenewalId: string]: {
            prescriptionTabModel: IPrescriptionTabModel,
            prescriptionRenewalMedications: PrescriptionRenewalMedications[],
            prescriptionRenewalNote: string,
            isDirty: boolean
        }
    } = {};
    public prescriptionRenewalHistoryFilterSetting: {
        [prescriptionRenewalId: string]: PrescriptionRenewalMedicationHistoryFilterSettingModel
    } = {};
    public isPrescriptionRenewalsViewPdfViewerExpanded: boolean = null;
    public isPrescriptionRenewalsViewRenewMedicationHeaderExpanded: boolean = null;

    constructor() {
        super();

        this.prescriptionRenewalsHandler = new PrescriptionRenewalsHandler();
        this.Mapper = new RequestMapper();
        this.Mapper.AddInstance(this.prescriptionRenewalsHandler);

        this.ClientDispatchToken = LocalEventDispatcher.register((request: LocalEvent) => {
            this.Mapper.Map(request, this);
        });
    }

    public static createSingleton(): PrescriptionRenewalsStore {
        return this.createStoreSingleton(defaultInstance, () => defaultInstance = new PrescriptionRenewalsStore());
    }
}

export { PrescriptionRenewalsStore, defaultInstance as prescriptionRenewalsStore };
